
import Api from '@/utils/api';
import Marquee from 'vux/src/components/marquee/marquee.vue'
import MarqueeItem from 'vux/src/components/marquee/marquee-item.vue'
import Scroller from 'vux/src/components/scroller/index.vue'
import XImg from 'vux/src/components/x-img/index.vue'
import LoadMore from 'vux/src/components/load-more/index.vue'
import querystring from 'vux/src/tools/querystring/index.js'
import Popup from 'vux/src/components/popup/index.vue'

import { wxConfigAjax, getIndex, addCart } from '../../api';
import MHead from './Head.vue';
import MSwiper from './swiper.vue';
import MSearch from './search.vue';
export default {
components: {
MHead,
MSwiper,
Scroller,
Marquee,
LoadMore,
MarqueeItem,
XImg,
Popup,
MSearch
},
methods: {
onScrollBtm() {
if (this.isMoreList) {
this.isMoreList = false;
this.page++;
this.getProductList();
}
},
getProductList() {
const searchParams = {
showInHome: true,
page: this.page,
pageSize: this.pageSize
};

this.loadText = '正在加载';
Api.getProductList(searchParams).then(res => {
this.productList = this.productList.concat(res.data);
if (this.productList.length < parseInt(res.headers.total)) {
this.isMoreList = true;
} else {
this.isMoreList = false;
this.loadText = '没有更多数据';
}
this.$nextTick(() => {
this.$refs.scrollerEvent.reset();
});
});
},
toPage(id) {
this.$router.push({
name: 'detail',
params: {
id: id
}
});
},
toClassify(category) {
console.log(category);
if (category.link) {
location.href = category.link;
} else {
this.$router.push({
name: 'classify',
query: {
categoryId: category._id
}
});
}
},
addCart(item_id, sku_id, className, url) {
let imgBox = document.querySelector(`.${className}`);
let relative = imgBox.getBoundingClientRect();

this.$store.commit('updateClassifyAnimate', {
x: relative.left,
y: relative.top,
headPic: url,
item_id: item_id,
sku_id: sku_id,
random: Math.random() * 10000
});
},
getData(cd) {
var that = this;
this.$store.commit('showIsLoading');
var test = querystring.stringify({
device: 'ios',
version: '1.2.0'
});
getIndex(test)
.then(res => {
console.log(res);
if (res.data.error_code != 0) {
console.log('错误信息：' + res.data.msg);
return;
}
wxConfigAjax({
title: res.data.data.shopInfo.shopname,
desc: res.data.data.shopInfo.shopname,
url: `home?shop_id=${res.data.data.shopInfo.shop_id}`,
imgUrl: res.data.data.shopInfo.shop_logo
});
let isDownLoad = localStorage.getItem('isDownLoad');
setTimeout(() => {
this.$store.commit('updateDownLoad', !isDownLoad ? true : false);
}, 300);
var data = res.data.data;

that.res = data;
this.$store.commit('updateShopInfo', data.shopInfo);
that.shopname = data.shopInfo.shopname;
that.slider = data.slider;
that.itemlist = data.itemShow[0].itemlist;
cd && cd();
})
.catch(err => {
this.$store.commit('hideIsLoading');
});
}
},
data() {
return {
page: 1,
pageSize: 50,
limit: 50,
isMoreList: true,
scrollH: '600px',
loadText: '',
banners: [],
navitems: [],
categories: [],
productList: [],
res: '',
shopname: '',
slider: '',
itemlist: '',
searchBox: false,
rollMessageList: []
};
},
mounted() {







Api.getHomePage().then(res => {
this.banners = res.data.banners;
this.navitems = res.data.navitems;
console.log(res);
});
Api.getCategoriesList({
showInHome: true
}).then(res => {
this.categories = res.data;
});
this.getProductList();
},
computed: {
getItemlist() {
var arr = this.itemlist;
for (let i = 0; i < arr.length; i++) {
arr[i].text = arr[i].title.substr(0, 4);
}
return arr;
},
isLogin() {
return this.$store.state.loginInfo;
}
},
watch: {
isLogin() {
this.getData();
}
},
created() {
setTimeout(() => {
var fontSize = parseInt(document.documentElement.style.fontSize);
var h = 0.94;

this.scrollH = document.documentElement.clientHeight - 36 - parseInt(h * fontSize) + 'px';
console.log(this.scrollH)
});
const that = this
window.onresize = () => {
return (() => {
var fontSize = parseInt(document.documentElement.style.fontSize);
var h = 0.94;

that.scrollH = document.documentElement.clientHeight - 36 - parseInt(h * fontSize) + 'px';
})()
}
}
};



// WEBPACK FOOTER //
// ./src/components/Home/Home.vue